import React, {Component} from 'react';
// import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import { slide as Menu } from 'react-burger-menu';
import logo from '../../../img/logo.svg';
import logoMobile from '../../../img/logo-mobile.svg';
import './ReportHeader.css';

import firebase from '../../../firebase';
import {history} from "../../../history";
import * as routes from '../../../constants/routes';

class ReportHeader extends Component {

    signOut(e){
        e.preventDefault();

        firebase.auth().signOut()
            .then(()=>{
                // Sign-out successful.
                history.push(routes.SIGN_IN);
            })
            .catch((err)=>{
                // An error happened.
                console.log(err);
            });

        return false;
    };

    render() {
        return (
            <section className="report-header">

                <Link to={routes.REPORT} className="report-header__link">
                    <picture>
                        <source media="(max-width: 767px)" srcSet={logoMobile}/>
                        <source media="(min-width: 768px)" srcSet={logo}/>
                        <img className="report-header__logo" src={logo} alt="logo"/>
                    </picture>
                </Link>
                
                <Menu
                 right
                 pageWrapId={"page-wrap"} 
                 outerContainerId={ "outer-container" }
                 width={280}
                 >
                    <a className="menu-item" onClick={()=>false}>Home</a>
                    <a className="menu-item" onClick={()=>false}>About</a>
                    <a className="menu-item" onClick={()=>false}>Contact</a>
                    <a className="menu-item" style={{cursor: "pointer"}} onClick={this.signOut}>Signout</a>
                </Menu>
            </section>
        );
    }
}

export default ReportHeader;


// WEBPACK FOOTER //
// ./src/components/Report/ReportHeader/ReportHeader.js